var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCctvIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 3.5,
    stroke: "#0E5B48"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.79867 8.57882C4.76786 8.50877 4.75115 8.43334 4.74952 8.35683C4.74788 8.28032 4.76135 8.20424 4.78914 8.13294C4.81693 8.06164 4.85851 7.99652 4.9115 7.9413C4.96448 7.88609 5.02783 7.84186 5.09793 7.81115L12.725 4.45348C13.3054 4.19798 14.02 4.48323 14.2679 5.06132L15.5571 8.06782C15.6784 8.35221 15.6819 8.6731 15.5668 8.96007C15.4518 9.24704 15.2276 9.47664 14.9434 9.59848L11.4213 11.1082L12.1446 12.9165H14.6663V11.1665H15.833V15.8332H14.6663V14.0832H12.1446C11.6645 14.0832 11.2393 13.795 11.0619 13.3493L10.3491 11.5678L7.31284 12.8687C7.17144 12.9293 7.01179 12.9317 6.86866 12.8752C6.72554 12.8187 6.61053 12.708 6.54867 12.5671L6.36667 12.1529L5.37442 12.5496L4.20776 9.6329L5.10376 9.27532L4.79867 8.57882ZM7.38517 11.569L14.4838 8.5269L13.1958 5.52157L6.10126 8.64473L7.38517 11.569Z",
    fill: "#2C3E50"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCctvIcon);
export default __webpack_public_path__ + "static/media/cctvIcon.ad5aeceffb01e7811abfe739a25c4f5b.svg";
export { ForwardRef as ReactComponent };